(function () {
function initScrollEnter(options = {}) {
const {
selector = '[data-scroll-enter]',
rootMargin = '0px 0px -15% 0px',
threshold = 0.2,
stagger = 120
} = options;

const blocks = document.querySelectorAll(selector);
if (!blocks.length) return;

const observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {
if (!entry.isIntersecting) return;

const container = entry.target;
const items = container.querySelectorAll(
'.enter-title, .enter-subtitle, .enter-content'
);

items.forEach((el, index) => {
el.style.transitionDelay = `${index * stagger}ms`;
el.classList.add('is-visible');
});

observer.unobserve(container);
});
}, { rootMargin, threshold });

blocks.forEach(block => observer.observe(block));
}

// 暴露到全局（Shopify 多 section 可用）
window.ScrollEnter = initScrollEnter;
})();